const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`
const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<style>
.ascend-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid var(--wa-panel-border-color, #E5E5E5);
  background: var(--wa-color-neutral-100, #FFF);
  box-shadow: var(--wa-shadow-offset-x-s, 0) var(--wa-shadow-offset-y-s, 2px) var(--wa-shadow-blur-s, 2px) var(--wa-shadow-spread-s, -1px) var(--wa-shadow-small, rgba(113, 113, 122, 0.12));
}
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: var(--ts-width-content-max, 1440px);
  padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  align-self: stretch;
}
.container-fluid {
  display: flex;
  max-width: var(----ts-width-content-max, 1440px);
  padding: 0 var(--wa-spacing-l, 24px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.contextual-fluid {
  display: flex;
  max-width: var(----ts-width-content-max, 1440px);
  padding: 0 var(--wa-spacing-l, 24px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.navheader-text {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--wa-color-neutral-40, #525252);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.right-group {
  display: flex;
  align-items: center;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: var(--wa-spacing-s, 12px);
}
.nav-item{
  display: flex;
  height: 40px;
  padding: 0 var(--wa-spacing-xs, 8px);
  align-items: center;
  gap: var(--wa-spacing-s, 12px);
}

.search-icon-button {
  display: flex;
  width: 20px;
  height: 20px;
  padding: var(--wa-spacing-3xs, 2px);
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.a {
  border-bottom: none;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Hamburger Button */
.hamburger {
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger span {
  height: 3px;
  width: 100%;
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Mobile Nav Menu */
.mobile-nav {
  display: none;
  transition: max-height 0.3s ease;
}

/* dynamic Toggle class */
.ascend-header-level1.menu-open .mobile-nav {
  display: flex;
}

.header-margin-class {
  margin: var(--wa-spacing-l) 24px 12px 12px 24px;
}




.profile-menu {
  display: flex;
  align-items: center;
}

.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
}
.utility-btn::part(base)  {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 var(--wa-spacing-xs, 8px);
  gap: var(--wa-spacing-2xs, 4px);
  border-radius: var(--wa-border-radius-m, 8px);
  border: var(--wa-border-width-s, 1px) solid var(--wa-color-neutral-50, #737373);
  background-color: #FFFFFF;
}
.utility-icon::part(svg) {
  fill: #404040;

}

.profile-btn::part(base),
.menu-btn::part(base) {
  display: flex;
  height: 40px;
  padding: 0 var(--wa-spacing-xs, 8px);
  align-items: center;
  gap: var(--wa-spacing-2xs, 4px);
  border-radius: var(--wa-border-radius-m, 8px);
  --wa-font-size-s: 14px;
  --wa-font-weight-semibold: 500;
  --wa-line-height-normal: 1.2;
  --wa-color-neutral-30: #3f3f46;
}
.profile-btn [slot='end'],
.menu-btn::part(caret) {
  margin-inline-start: 0 !important;
}
.utility-btn [slot='start'],
.profile-btn [slot='start'],
.menu-btn::part(caret) {
  margin-inline-end: 0 !important;
}

.profile-btn::part(start) {
  display: flex;
  width: 20px;
  height: 20px;
  padding: var(--wa-spacing-3xs, 2px);
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.profile-btn::part(label) {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--wa-color-neutral-30, #404040);
  text-align: center;
  font-size: var(--wa-font-size-s, 14px);
  font-style: normal;
  font-weight: var(--wa-font-weight-semibold, 500);
  line-height: 150%;
  padding: 0 var(--wa-spacing-2xs, 4px);
}

.profile-btn::part(caret) {
  display: flex;
  width: 14px;
  height: 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
}


.menu-btn::part(label) {
  display: flex;
  padding: 0 var(--wa-spacing-2xs, 4px);
  justify-content: center;
  align-items: center;
}

.menu-btn::part(end) {
  display: flex;
  align-items: center;
  margin-left: var(--wa-spacing-2xs, 4px);
}

.menu-btn::part(caret) {
  display: flex;
  width: 14px;
  height: 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
}

.ham-btn {
  display: flex;
  width: var(--wa-spacing-l, 24px);
  height: var(--wa-spacing-l, 24px);
  padding: var(--wa-spacing-3xs, 2px);
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  display: none;
}
.navheader-utility {
  display: flex;
  align-items: center;
  gap: var(--wa-spacing-l, 24px);
}
.profile-label {
  display: block;
  text-overflow: ellipsis; 
}

.header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: nowrap;
}
  
.profile-icon::part(svg) {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  fill: #404040;
}
.header-icon::part(svg) {
  width: var(--wa-spacing-m, 16px);
  height: var(--wa-spacing-m, 16px);
  flex-shrink: 0;
}


.group-icon {
  display: flex;
  align-items: center;
}



.bell-icon {
}

.nav-horizontal {
  display: flex;
  gap: 1rem;
}

div img {
  width: 160px;
  height: 40px;
}
.contextual-btn {
  display: flex;
  height: 40px;
  padding: 0 8px;
  align-items: center;
  gap: var(--wa-spacing-2xs, 4px);
}

.contextual-btn::part(base)  {
  border-radius: var(--wa-border-radius-square, 0);
  background: var(--ts-appearance-fill-loud, #2E69FF);

}

.contextual-btn::part(label)  {
  display: flex;
  padding: 0 var(----sl-spacing-2x-small, 4px);
  justify-content: center;
  align-items: center;
  color: var(--ts-appearance-on-loud, #FFF);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}

.utility-btn::part(label),
.profile-btn::part(label) {
  display: flex;
  padding: 0 var(--wa-spacing-2xs, 4px);
  justify-content: center;
  align-items: center;
  color: var(--wa-color-neutral-30, #404040);
  text-align: center;
  font-family: var(--wa-font-family-sul-sans, "Sul Sans");
  font-size: var(--wa-font-size-s, 14px);
  font-style: normal;
  font-weight: var(--wa-font-weight-semibold, 500);
  line-height: 150%;
}
.contextual-links {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
.contextual-link-btn {
  display: flex;
  width: 99px;
  height: 40px;
  padding: 0 var(--wa-spacing-xs, 8px);
  align-items: center;
  gap: var(--wa-spacing-2xs, 4px);
  
}
.contextual-link-btn::part(label) {
  display: flex;
  padding: 0 var(----sl-spacing-2x-small, 4px);
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: var(--wa-font-family-sul-sans, "Sul Sans");
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */

}
.contextual-link-btn::part(caret) {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.contextual-link-btn.menu-active {
  border-bottom: 2px solid var(--wa-color-primary-50, #2E69FF);
  background: var(--wa-color-neutral-90, #F5F5F5);
}

.contextual-link-btn.menu-active::part(label) {
  color: var(--wa-color-primary-50, #2E69FF);
}

.mobile-menu-link {
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease;
}
.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-menu {
  display: flex;
  width: 222px;
  max-width: 100vw;
  min-width: 160px;
  padding: var(--wa-spacing-s, 12px) 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--wa-spacing-s, 12px);
  border-radius: var(--wa-border-radius-s, 4px);
  border: 1px solid var(--wa-panel-border-color, #E5E5E5);
  background: var(--wa-color-neutral-100, #FFF);
  box-shadow: var(--wa-shadow-offset-x-m, 0) var(--wa-shadow-offset-y-m, 4px) var(--wa-shadow-blur-m, 4px) var(--wa-shadow-spread-m, -2px) var(--wa-shadow-medium, rgba(113, 113, 122, 0.12));
  position: absolute;

}


.dropdown-item {
  display: flex;
  padding: var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
  align-items: center;
  gap: 3px;
  align-self: stretch;
}
.dropdown-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.mobile-profile-menu {
  display: none;
}

@media only screen and (min-width: 320px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);
  }
  
}

@media only screen and (max-width: 576px) {
  
  .ascend-header {
    /* mobile overrides */
  }
  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);  
  }
  
  .utility-btn::part(base) {
    height: 30px;
  }
  .utility-btn::part(label),
  .profile-btn::part(label) {
    padding: 0 var(--wa-spacing-3xs, 2px);
    
  }
  .profile-btn::part(base) {
    display: flex;
    width: 20px;
    height: 20px;
    padding: var(--wa-spacing-3xs, 2px);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
  .profile-btn::part(label) {
    display: none;
  }
  .profile-btn::part(caret) {
    display: none;
  }
  .profile-icon::part(svg) {
    width: var(--wa-spacing-m, 16px);
    height: var(--wa-spacing-m, 16px);
    flex-shrink: 0;
    fill: #404040;
  }
  .ham-btn {
    display: flex;
    width: var(--wa-spacing-l, 24px);
    height: var(--wa-spacing-l, 24px);
    padding: var(--wa-spacing-3xs, 2px);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;  
  }
  .container-fluid {
    display: flex;
    max-width: 375px;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    padding: 0;
  }
  .nav-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
  }
  .nav-item {
    display: flex;
    width: 343px;
    height: var(--wa-spacing-2xl, 40px);
    padding: 0 var(--wa-spacing-m, 16px);
    align-items: center;
    gap: var(--wa-spacing-s, 12px);
    align-self: stretch;
  }
  .nav-divider {
    display: flex;
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
  }
  
  .divider-line {
    width: 343px;
    height: var(--wa-border-width-s, 1px);
    background: #D9D9D9;
    align-self: stretch;
  }
  .menu-btn::part(base) {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 18px var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  
  
  .dropdown-menu {
    display: flex;
    width: 375px;
    padding: var(--wa-spacing-xs, 8px) 0;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--wa-spacing-xs, 8px);
    border-radius: var(--wa-border-radius-square, 0);
    border-top: 1px solid var(--wa-panel-border-color, #E5E5E5);
    background: var(--wa-color-neutral-100, #FFF);
    box-shadow: var(--wa-shadow-offset-x-m, 0) var(--wa-shadow-offset-y-m, 4px) var(--wa-shadow-blur-m, 4px) var(--wa-shadow-spread-m, -2px) var(--wa-shadow-medium, rgba(113, 113, 122, 0.12));
    margin-left: auto;
    margin-right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .contextual-label {
    display: flex;
    padding: var(--wa-spacing-xs, 8px) var(--wa-spacing-m, 16px);
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    align-self: stretch;
  }
  .contextual-btn::part(base)  {
    display: flex;
    width: 335px;
    height: 30px;
    padding: 0 4px;
    justify-content: center;
    align-items: center;
    gap: var(--wa-spacing-3xs, 2px);
    align-self: stretch;
  }
  .mobile-primaryMenu {
    display: none;
  }
  .right-group {
    display: none;
  }
  .navitem-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--wa-spacing-2xs, 4px);
    align-self: stretch;
  }
  .inside-navitem-container {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 18px var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  .menuitem-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--wa-spacing-2xs, 4px);
    align-self: stretch;
  }

  .dropdown-item {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 18px var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .new-dropdown-menu {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 0 var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    align-items: center;
    gap: 6px;
    align-self: stretch;
  }
  .new-dropdown-separator {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 0 var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    align-items: center;
    gap: 6px;
    align-self: stretch;
    height: 159px;
    width: 359px;
  }
  .new-dropdown-item {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 18px var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
  .contextual-btn-container {
    display: flex;
    padding: var(--wa-spacing-xs, 8px) var(--wa-spacing-m, 16px);
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    align-self: stretch;
  }
  .contextual-link-btn {
    display: flex;
    width: 20px;
    height: 20px;
    padding: 2px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    background: none;

  
  }
    
}

@media only screen and (min-width: 768px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
  
}

@media only screen and (min-width: 992px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

@media only screen and (min-width: 1200px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

@media only screen and (min-width: 1440px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

.open {
  display: block;
}

.closed {
  display: none;
}
</style>
`
const TemplateNavHeaderStyles = t
export { TemplateNavHeaderStyles }
